import a from "./index5.js";
import { openBlock as t, createElementBlock as r, createElementVNode as s, withKeys as i, withDirectives as p, Fragment as m, renderList as h, normalizeClass as v, withModifiers as f, vShow as y, renderSlot as l } from "vue";
import "./index6.js";
import $ from "../../../../_virtual/index.js";
const c = { class: "search-input" }, w = { class: "search-input-controls" }, M = { class: "search-input-area" }, N = ["placeholder"], I = { class: "search-results" }, k = { id: "autocomplete-list" }, K = ["id", "onClick", "onMouseenter"], S = ["innerHTML"], E = ["innerHTML"];
function F(e, o, H, L, g, P) {
  return t(), r("div", c, [
    s("div", w, [
      s("div", M, [
        s("input", {
          type: "text",
          autocomplete: "off",
          name: "search",
          placeholder: e.placeholder,
          onInput: o[0] || (o[0] = (n) => e.debounce(
            () => e.updateQuery(n.target.value),
            250
          )),
          onKeyup: o[1] || (o[1] = i((...n) => e.handleInputEnterKeyPress && e.handleInputEnterKeyPress(...n), ["enter"])),
          onKeydown: [
            o[2] || (o[2] = i((n) => e.handleArrowKeyPress(!1), ["down"])),
            o[3] || (o[3] = i((n) => e.handleArrowKeyPress(!0), ["up"]))
          ],
          onFocus: o[4] || (o[4] = (n) => e.inputIsFocused = !0),
          onBlur: o[5] || (o[5] = (n) => e.inputIsFocused = !1)
        }, null, 40, N),
        p(s("div", I, [
          s("ul", k, [
            (t(!0), r(m, null, h(e.filteredSuggestions, (n, u) => (t(), r("li", {
              key: n.productName,
              id: e.getAutocompleteId(u),
              class: v(["search-results-item", {
                "active-item": e.currentName === n.productName
              }]),
              onClick: (d) => e.onSelected(n),
              onMousedown: o[6] || (o[6] = f(() => {
              }, ["prevent"])),
              onMouseenter: (d) => e.onMouseEnter(n.productName)
            }, [
              e.algoliaExpVar === "N" ? (t(), r("div", {
                key: 0,
                innerHTML: n.productNameHighlight?.value
              }, null, 8, S)) : (t(), r("div", {
                key: 1,
                innerHTML: e.highlightSuggestionName(n.productName)
              }, null, 8, E))
            ], 42, K))), 128))
          ])
        ], 512), [
          [y, e.hasSuggestions && e.inputIsFocused]
        ])
      ]),
      l(e.$slots, "search-submit"),
      l(e.$slots, "search-icon")
    ])
  ]);
}
const b = /* @__PURE__ */ $(a, [["render", F]]);
export {
  b as default
};
//# sourceMappingURL=index4.js.map
